import { UpdateInformationType } from 'src/app/shared/types/my-account.types';

export namespace MyAccountAction {
  export class GetUserDetail {
    static readonly type = '[MyAccountAction] GetUserDetail';
    constructor() {}
  }

  export class UpdateUserDetail {
    static readonly type = '[MyAccountAction] Update';
    constructor(public body: UpdateInformationType) {}
  }
}
